import { FC, useMemo } from 'react';

import { TransactionType } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useFormatter, useTranslations } from '@ravago/shared/translations/client';

import { calculateOverDueDays, isOverDue } from '../../../../../utils/invoice-date.utils';

type Props = {
   dueDate: string;
   invoiceType: TransactionType;
};

export const InvoiceDueDate: FC<Props> = ({ dueDate, invoiceType }) => {
   const translate = useTranslations();
   const format = useFormatter();

   const isCheque = invoiceType === TransactionType.CHEQUE;
   const isInvoiceOverDue = useMemo(() => isOverDue(dueDate), [dueDate]);
   const overDueDays = useMemo(() => calculateOverDueDays(dueDate), [dueDate]);

   if (isInvoiceOverDue) {
      return (
         <Box direction="column" gap="3xs">
            <Typography variant="small-highlight" color="error">
               {format.dateTime(dueDate)}
            </Typography>
            <Typography variant="caption" color="error">
               {translate(`invoices.open-invoices.table.past-due${overDueDays === 1 ? '-singular' : ''}`, { dueDays: overDueDays })}
            </Typography>
         </Box>
      );
   }

   return (
      <Box direction="column" gap="3xs">
         <Typography variant="small">{dueDate ? format.dateTime(dueDate) : ''}</Typography>
         {isCheque && <Typography variant="caption">{translate('invoices.open-invoices.table.date-of-cashing')}</Typography>}
      </Box>
   );
};
